export const H5_SESSION_EXPIRED_EVENT = 'h5-session-expired'

export function isH5SessionExpired(httpStatus: number, apiCode?: number) {
  return httpStatus === 401 || apiCode === 401
}

export function notifyH5SessionExpired(target: Pick<EventTarget, 'dispatchEvent'> = window) {
  target.dispatchEvent(new Event(H5_SESSION_EXPIRED_EVENT))
}
